export default __webpack_public_path__ + "static/media/arrow-back.54716086.svg";